module.exports = function () {
	return require("./index").apply(this, arguments);
}


//////////////////
// WEBPACK FOOTER
// ./__main_entry.tmp.js
// module id = 81
// module chunks = 4